module.exports = __webpack_public_path__ + "static/media/malak.5af923fd.webp";